import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";

// import logo from "../../images/logo.svg";

export const NavBar = () => {
  return (
    <Navbar sticky="top">
      <Container>
        <a
          href="https://tfg.lk"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "none" }}
        >
          <Navbar.Brand>
            {"pitch "}
            <img
              src={
                "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-tech-for-good/Learn/tfg-logo-01.png"
              }
              className="d-inline-block align-top"
              height="40"
              alt="tech for good logo"
            />
          </Navbar.Brand>
        </a>
        {/* <Nav className="justify-content-end">
          <MainMenu />
        </Nav> */}
      </Container>
    </Navbar>
  );
};
